module.exports = __webpack_public_path__ + "img/whitepaper.3f945b1a.svg";